import Model from '../model';
import { sanitize } from 'api/utils';
import { CREATE_BUY } from 'api/graphql/shop';

const types = {
    items: String,
    customerPhone: String,
    customerName: String,
    customerSurname: String,
    customerEmail: String,
    customerSex: String,
    customerBirthday: String,
    customerSkype: String,
    comment: String,
    index: String,
    address: String,
    city: String,
    region: String,
    country: String,
    delivery: String,
    oldAddress: String,
    tarif: Number,
    price: String,
    pvz: String,
    paymentSystem: String,
    utmSource: String,
    utmMedium: String,
    utmContent: String,
    saleSum: Number
}
export const createBuy = async (variables) => {
    return Model.apollo.mutate({
        mutation: CREATE_BUY,
        variables: sanitize(variables, types)
    }).then((response) => {
        return processBuyResponse(response);
    });
}

export const processBuyResponse = (response) => {
    if (response['data']?.['createBuy']?.['buy'] === undefined || response['data']?.['createBuy']?.['buy'] === null) {
        return {
            error: response['data']?.['createBuy']?.['error'] || `no valid response from server, received: ${response}`
        }
    }
    const paymentStatus = response['data']?.['createBuy']?.['buy']?.['payment']?.['status'];
    const alfa = response['data']?.['createBuy']?.['buy']?.['payment']?.['alfa'];
    const yandex = response['data']?.['createBuy']?.['buy']?.['payment']?.['yandex']
    const payUrl = alfa?.['payUrl'] || yandex?.['payUrl'];

    return {
        body: response['data']?.['createBuy']?.['buy'],
        payUrl,
        paymentStatus,
        error: response['data']?.['createBuy']?.['error']
    }
}
